'use strict';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

class Menu {

    constructor($target) {

        let self = this;
        self.$target = $target;

        // let bgBody = document.createElement('div');

        let hamburger = self.$target.find('#hamburger');
        let menuHeader = self.$target.find('.menu-header');
        let menuHeaderItems = self.$target.find('.menu-header a');
        let headerElements = self.$target.find('.header__elements');

        let flexContent = document.querySelector('.flex_content');
        let  aboutPanel = document.querySelector('.component_paragraph_long');

        let scrollState = 'top';

        let bgHeader = document.createElement('div');
        // $(bgHeader).addClass('header__move');

       
        let menuOpenSmallScreen = window.matchMedia("(max-width:768px)");
        let menuOpenMediumScreen = window.matchMedia("(min-width:768px)");
        let menuOpenScreen = window.matchMedia("(min-width:1200px)");
        //
        let menuAnimationScreen = window.matchMedia("(min-width:1200px)");
        let menuOpenBigScreen = window.matchMedia("(min-width:1500px)");
        
        let tl = gsap;
        let onEnterTimeline = gsap.timeline({repeat: 0, repeatDelay: 0 });
        var lastScrollTop = 0;
        function init() {
            addEventListeners()

            detectHomepage();
            changeMenuColorOnFlex();

            defineEnterTimeline();
            //defineLeaveTimeline();
            
            menuHeaderItems.on("click", (e)=> {
              //stop link propagation
              e.preventDefault()


              
              //Immediately start to load the page once the visitor clicks
              window.location.href = e.target.href
              
              toggleMenu()

            //   if ( e.target.hash && e.target.hash === "#about-all3media"){

            //     window.scroll({
            //         behavior: 'smooth',
            //         left: 0,
            //         top: aboutPanel.getBoundingClientRect().height * 2
            //     });
            //   }
              
            
            })

            $(window).scroll(hideMenuOnScroll);
            $(document).click(hideMenuOnOutsideClick);

        }

        function addEventListeners(){

          //click the menu
          $(hamburger).on("click", (toggleMenu));
      
        }

        function toggleMenu(event){
          event.stopPropagation();
          //the menu is open
          $(hamburger).toggleClass('open');

          $(menuHeader).toggleClass("open");
          $(menuHeaderItems).toggleClass("open");
       
          if($(hamburger).hasClass('open')){
            onEnterTimeline.play();
            //hide element that confuse 
            $(bgHeader).css('display', 'none');
          
          }else{
            onEnterTimeline.reverse();

            //show the element if menu is close
            $(bgHeader).css('display', 'block');
            $('body').css('overflow', 'auto');
            $(headerElements).css('position', 'fixed');
     
          }

        }
        

        function defineEnterTimeline(){
  
          onEnterTimeline.fromTo(menuHeader[0], { x:"100%"},{x:"0%", duration:0.09})
          onEnterTimeline.fromTo(menuHeaderItems, {opacity:0, x:20}, {opacity:1, x:0, delay:  -0.1, duration:0.1, stagger:0.09})
          onEnterTimeline.pause();

        }
        
        function detectHomepage(){

          //detect if it's the homepage 

          if ( (window.location.pathname == '/') ){

            if(menuAnimationScreen.matches){
                // if it's the homepage  and it's desktop 
                $(window).on("scroll", (function(){ 
                  //on scroll animate the header
                  animateHeader()
                }));
            }
            
            } else {
              $(bgHeader).appendTo('body');
          }

          if(window.matchMedia("(max-width:1200px)").matches){
            $(bgHeader).appendTo('body');
          }
        }

        function changeMenuColorOnFlex(){
         if ( $(flexContent).length ) {
          if(menuOpenMediumScreen.matches){ 
              $(hamburger).children('.hamburgerSpan').css('background', '#221f1f')
            }else{
              $(hamburger).children('.hamburgerSpan').css('background', '#FFFFFF')
            }
          }
        }

        function animateHeader(){
          var scrollPos = $(window).scrollTop();

          if( ( scrollPos != 0 ) && ( scrollState === 'top' ) ) {
        
             
              $(menuHeader).removeClass("open");
              $(hamburger).removeClass("open");

              onEnterTimeline.reverse();

              scrollState = 'scrolled';
              

          
          }       
          else if( ( scrollPos === 0 ) && ( scrollState === 'scrolled' ) ) {

              scrollState = 'top';

          }
        }

        function hideMenuOnEvents(){
          if (menuHeader.hasClass('open')) {
            setTimeout(function () {
              menuHeader.removeClass('open');
              hamburger.removeClass('open');
              onEnterTimeline.reverse();
            }, 500);
          }
        }


        function hideMenuOnScroll(){
              var st = $(this).scrollTop();
              if (st > lastScrollTop){
                  // scrolling down
                  hideMenuOnEvents();

              } else {
                  // scrolling up
                  hideMenuOnEvents();
              }
              lastScrollTop = st;
          
        }

        function hideMenuOnOutsideClick(){
          hideMenuOnEvents();
        }


        init();

        return {

        }

    }

}

export default Menu;
